"use client";

import { clsx } from "clsx";

export default function TabSwitcher({
  tabs,
  selected,
  onChange,
  className = "",
}) {
  return (
    <div
      className={clsx(
        "scrollbar-hide scrollbar-hide overflow-x-auto",
        className,
      )}
    >
      <div className="flex w-max gap-2 whitespace-nowrap">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={clsx(
              "h-9 cursor-pointer rounded-lg border px-3",
              selected === tab.id
                ? "border-primary text-primary bg-primary-weaker font-normal"
                : "text-foreground border-transparent font-normal",
            )}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
